import { configure, onReactionError, spy } from 'mobx'
import { logger } from 'services/logger'

export const configureMobx = (enableMobxSpy: boolean) => {
  configure({
    enforceActions: 'observed',
    computedRequiresReaction: true,
    reactionRequiresObservable: false,
    observableRequiresReaction: true,
    disableErrorBoundaries: false,
  })

  if (enableMobxSpy) {
    onReactionError((error, reaction) => {
      logger.error('MobX reaction failed:', {
        reactionName: reaction.name_ || 'unnamed reaction',
        error: String(error),
        stack: error.stack,
      })
    })

    spy((evt) => {
      if (evt.type === 'action' || evt.type === 'reaction') {
        logger.info(`[mobx] ${evt.type} ${evt.name}`, evt)
      }
    })
  }
}
